<span style="align-items: center;">
  <a [href]="releaseNotesUrl" target="_blank" rel="noopener noreferrer" class="button" fxHide fxShow.gt-sm mat-button fxFlex="grow"
    [attr.aria-label]="LangTextData.tooltipLabel.toolBoxReleaseNotes" [matTooltip]="LangTextData.tooltipLabel.toolBoxReleaseNotes" matTooltipClass="table_tooltip_job_filename"
    matTooltipPosition="below">
    <mat-icon aria-hidden="true">new_releases</mat-icon>
  </a>
</span>